<template>
  <div @contextmenu.prevent>
    <v-card tile class="menu-bar">
      <GroupSelector />
      <div class="menu-bar-center">
        <ul class="menu-bar-center-list d-flex justify-space-between">
          <li class="menu-prime d-inline-block" v-for="(primeMenu, idx) in primeMenuList" :key="idx">
            <a :menu-id="primeMenu.id" @click="setPrimeMenu(primeMenu.id)" :class="idx == 0 ? 'active' : ''">
              <v-icon left>{{ primeMenu.icon }}</v-icon>
              <span v-html="$t(primeMenu.messageCode)" />
            </a>
          </li>
        </ul>
      </div>
      <div class="menu-bar-right">
        <ul class="menu-bar-right-list">
          <li class="menu-sub d-inline-block" v-for="(subMenu, idx) in subMenuList" :key="idx">
            <a :menu-id="subMenu.id" @click="setSubMenu(subMenu.id)" :class="idx == 0 ? 'active' : ''">
              <v-icon left>{{ subMenu.icon }}</v-icon>
              <span v-html="$t(subMenu.messageCode)" />
            </a>
          </li>
        </ul>
      </div>
    </v-card>
    <v-slide-y-transition>
      <div v-show="showDetailMenu" class="menu-detail" :class="subMenuPos">
        <div>
          <v-card class="content-detail" v-click-outside="{ handler: onClickOutside, include: getOutsideIncludes }">
            <v-btn small v-for="(menu, idx) in detailMenuList" :key="idx" @click="setDetailMenu(menu)" class="btn-detail">
              <v-icon small>{{ menu.icon }}</v-icon>
              <span v-html="$t(menu.messageCode)" :class="{ selected: $router.currentRoute.fullPath.startsWith(menu.url) }" />
            </v-btn>
          </v-card>
        </div>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GroupSelector from './GroupSelector.vue';
import bus from '@/utils/bus';

export default {
  components: {
    GroupSelector,
  },
  data: () => ({
    primeMenu: '',
    primeMenuList: [],
    subMenu: '',
    subMenuPos: '',
    subMenuList: [],
    detailMenu: '',
    detailMenuList: [],
    showDetailMenu: false,
  }),
  watch: {
    // primeMenuList: {
    //   handler(value, before) {
    //     if (!before.length) this.primeMenu = this.primeMenuList[0].id;
    //   },
    // },
    primeMenu: {
      handler: 'changePrimeMenuHandler',
    },
    subMenu: {
      handler: 'changeSubMenuHandler',
    },
    stackType: {
      handler: 'changeStackTypeHandler',
    },
  },
  computed: {
    ...mapState('common/system', ['system', 'stackType']),
    ...mapState('common/menu', ['realtime', 'analstatic']),
    ...mapGetters('common/system', ['getSystemById']),
    stackType() {
      return ((this.system || {}).stackType || '').toLowerCase();
    },
  },
  methods: {
    changeStackTypeHandler() {
      const firstPrimeMenu = (this.primeMenuList[0] || {}).id;
      // primeMenuList 의 첫번째 menu id 가 현재 선택된 menu id 와 상이할 경우 현재 menu id 값을 변경함으로서 watch 실행을 유도함.
      if (firstPrimeMenu != this.primeMenu) this.primeMenu = firstPrimeMenu;
      // menu id 가 동일할 경우 watch 실행이 되지 않으므로, handler 를 임의로 실행시킴.
      else this.changePrimeMenuHandler(firstPrimeMenu);
    },
    changePrimeMenuHandler(value) {
      this.subMenuList = this.getSubMenuList(value);
      this.subMenu = this.subMenuList[0].id;
    },
    changeSubMenuHandler(value) {
      this.detailMenuList = this.getDetailMenuList(value);
    },
    setPrimeMenu(primeMenu) {
      let subMenuPos = 'left';
      const selected = document.querySelector(`a[menu-id="${primeMenu}"]`);
      Array.from(document.querySelectorAll('li.menu-prime > a')).forEach(item => {
        if (item == selected) {
          item.classList.add('active');
          if (item.offsetLeft > 100) {
            subMenuPos = 'right';
          } else {
            subMenuPos = 'left';
          }
        } else item.classList.remove('active');
      });
      Array.from(document.querySelectorAll('li.menu-sub > a')).forEach((item, index) => {
        if (!index) item.classList.add('active');
        else item.classList.remove('active');
      });
      this.showDetailMenu = this.primeMenu == primeMenu ? !this.showDetailMenu : true;
      this.subMenuPos = subMenuPos;
      this.primeMenu = primeMenu;
    },
    setSubMenu(subMenu) {
      const selected = document.querySelector(`a[menu-id="${subMenu}"]`);
      Array.from(document.querySelectorAll('li.menu-sub > a')).forEach(item => {
        if (item == selected) {
          item.classList.add('active');
        } else item.classList.remove('active');
      });
      if (this.getDetailMenuList(subMenu).length) {
        this.showDetailMenu = this.subMenu == subMenu ? !this.showDetailMenu : true;
      } else {
        this.showDetailMenu = false;
        this.setDetailMenu(this.subMenuList.filter(item => item.id == subMenu)[0]);
      }
      this.subMenuPos = 'right';
      this.subMenu = subMenu;
    },
    setDetailMenu(menu) {
      if (this.$router.currentRoute.fullPath.startsWith(menu.url)) return;
      if (this.isStackTypedDetailPage(menu.url) || this.isStackTypeSystemPage(menu.url)) {
        this.$router.push(`${menu.url}/${this.system.id}`);
      } else {
        this.$router.push(menu.url);
      }
      this.showDetailMenu = false;
    },
    getSubMenuList(primeMenu) {
      return this.primeMenuList
        .filter(menu => (primeMenu ? menu.id == primeMenu : true))
        .reduce((acc, item) => acc.concat(item.children), [])
        .filter(item => item.name == this.stackType || item.name == '');
    },
    getDetailMenuList(subMenu) {
      return this.subMenuList.filter(menu => menu.id == subMenu).reduce((acc, item) => acc.concat(item.children || []), []);
    },
    getOutsideIncludes() {
      const menuPrimeButtons = Array.from(document.querySelectorAll('.menu-prime a'));
      const menuSubButtons = Array.from(document.querySelectorAll('.menu-sub a'));
      return menuPrimeButtons.concat(menuSubButtons);
    },
    onClickOutside() {
      this.showDetailMenu = false;
    },
    getStackTypeUrls(stackType) {
      const [{ children: realtimeMenus }] = this.realtime;
      const [{ children: menu }] = realtimeMenus.filter(m => m.name == stackType.toLowerCase());
      return menu.map(s => s.url);
    },
    isStackTypedDetailPage(url) {
      return url.indexOf('/views/detailview') > -1;
    },
    isStackTypeSystemPage(url) {
      return url.indexOf('/views/overview/system') > -1;
    },
  },
  created() {
    this.primeMenuList = this.realtime.concat(this.analstatic);
    // console.log('in Gnb.vue, this.primeMenuList', this.primeMenuList);
    this.primeMenu = (this.primeMenuList[0] || {}).id;

    bus.$on('change:group-selector-systemId', param => {
      const setSystem = systemId => this.$store.dispatch('common/system/setSystem', systemId);
      const { stackType } = this.getSystemById(param.systemId);
      const { stackType: beforeStackType } = param.beforeSystemId ? this.getSystemById(param.beforeSystemId) : { stackType: '' };
      // stackType 변경에 의존적인 페이지일 경우
      // route 변경 후 systemId store 값을 지정한다.
      if (this.isStackTypedDetailPage(this.$route.path)) {
        if (stackType != beforeStackType) {
          // 현재 url 이 이전 stackType 에 속해있을 경우 현재 stackType의 첫번째 페이지로 이동한다.
          if (this.getStackTypeUrls(beforeStackType).includes(this.$route.meta.path)) this.$router.push(`${this.getStackTypeUrls(stackType)[0]}/${param.systemId}`, () => setSystem(param.systemId));
          // url 직접 접근일 경우 이미 route 처리가 완료된 상태이며, store 값만 지정한다.
          else setSystem(param.systemId);
        } else {
          // stackType 의 변동이 없을 경우 변경된 systemId 를 반영한 url 로 이동한다.
          this.$router.push(`${this.$route.meta.path}/${param.systemId}`, () => setSystem(param.systemId));
        }
      } else if (this.isStackTypeSystemPage(this.$route.path)) {
        this.$router.push(`${this.$route.meta.path}/${param.systemId}`, () => setSystem(param.systemId));
      } else {
        // 그 이외의 페이지일 경우 router 변경여부와는 상관없이 systemId store 값을 지정한다.
        setSystem(param.systemId);
      }
    });
  },
};
</script>
